import {fromJS} from 'immutable';

import {
  ADD_NOTIFICATION,
  DELETE_NOTIFICATION,
  UPDATE_NOTIFICATION_SETTING
} from './actions';

export const initialState = fromJS({
  items: {},
  settings: {
    isSupported: null,
    permission: null
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const {notificationId, type, details} = action.payload.notification;
      const notification = {
        notificationId,
        type,
        details
      };

      return state.setIn(['items', notificationId], notification);
    }

    case DELETE_NOTIFICATION:
      return state.deleteIn(['items', action.payload.notificationId]);

    case UPDATE_NOTIFICATION_SETTING:
      return state.mergeDeepIn(['settings'], action.payload.setting);

    default:
      return state;
  }
}
